/* global axios */
// O axios GLOBAL (window.axios) e o que carrega os headers de auth do
// DeviseTokenAuth; importar 'axios' cru aqui daria 401 em toda chamada.
import ApiClient from './ApiClient';

// Relatorio de campanhas da conta inteira, todos os canais.
//
// O endpoint antigo (whatsapp_campaign_metrics) vive aninhado numa caixa e so
// enxerga WhatsApp oficial. Aqui a caixa e filtro opcional, e cada campanha vem
// com o que o canal dela consegue informar.
class CampaignReportsAPI extends ApiClient {
  constructor() {
    super('campaign_reports', { accountScoped: true });
  }

  get({ from, to, inboxId } = {}) {
    return axios.get(this.url, {
      params: { from, to, inbox_id: inboxId || undefined },
    });
  }

  // As conversas que formam UM numero da linha. E o que torna o numero
  // conferivel: sem isso o usuario so pode acreditar no total.
  recipients(campaignId, { status, page = 1 } = {}) {
    return axios.get(`${this.url}/${campaignId}/recipients`, {
      params: { status, page },
    });
  }
}

export default new CampaignReportsAPI();
